import React from 'react'
import styles from "./AboutCompaney.module.css"
import vissionbackground from "./vission.png";
import missionlogo from "./mission.png";
export const AboutCompany = () => {
    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>
                About CirkiTex
            </h2>
            <p className={styles.details} style={{ fontSize: "1.3em",textAlign: "center" }}>
                CirkiTeX is developing hardware accelerators for Edge AI applications, delivering high-performance, energy-efficient,
                and scalable solutions for industries worldwide. Our technology is tailored to optimize AI workloads, providing the computational
                power needed to drive innovation and enhance operational efficiency in various sectors.
            </p>
            <div className={styles.box}>
                <div className={styles.item}>
                    <img src={vissionbackground} className={styles.image} alt="Vision" />

                    <div className={styles.info}>
                        <h3 className={styles.name} >Vision </h3>
                        <span className={styles.visionDetail} >Building intelligent, energy-efficient semiconductor solutions that bring AI to the Edge.</span>
                    </div>
                </div>
                <div className={styles.item}>
                    <img src={missionlogo} alt="Mission" />

                    <div className={styles.info}>
                        <h3 className={styles.name} >Mission </h3>
                        <span className={styles.visionDetail} >To drive indigenous innovation, create scalable products, and make cutting-edge semiconductor technology accessible and impactful.</span>

                    </div>
                </div>
            </div>
            <p className={styles.details} style={{ textAlign: "center", fontSize: "1.3em" }}>
                We have been consistently pushing the
                boundaries of semiconductor technology
                with a team of world-class engineers and innovators.
                Our focus is on developing
                cutting-edge products that accelerate machine
                learning, enhance automation, and promote a more connected world.
            </p>


        </div>
    )
}
